import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import api from 'api';
import { showMessage } from 'actions/index';

function RecipeShare() {
    const dispatch = useDispatch();
    const history = useHistory();
    const { id, profile } = useParams();

    useEffect(() => {
        api('recipes/share/' + id + '/' + profile, { post: true, data: { description: localStorage.getItem('shareMenuDescription') } }).then(() => {
            dispatch(showMessage({ show: true, type: 'success', message: 'Recept byl sdílen na Váš profil.' }));
            history.push('/recipe/me');
        });
    }, []);

    return null;
}

export default RecipeShare;
